import { useState, useEffect } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from '../../context/auth-context'
import { Helmet } from 'react-helmet-async'
import { API_BASE_URL } from 'config/api'
import { getValidAccessToken } from 'utils/tokenManager'

// const apiUrl = 'https://api.gobookstory.com'

interface IFormInput {
  firstName: string
  lastName: string
  email?: string
}

export const UpdatePersonalInfoForm = () => {
  const { user } = useAuth()
  const [show, setShow] = useState(false)
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    setFocus,
    formState: { errors },
  } = useForm<IFormInput>()
  const onSubmit: SubmitHandler<IFormInput> = async (options) => {
    try {
      const userToken = await getValidAccessToken()
      let customerId = user.id
      let data = {
        firstName: options.firstName,
        lastName: options.lastName,
        email: options.email,
      }
      const config = {
        method: 'PUT',
        data: data,
        url: `${API_BASE_URL}/customers/${customerId}`,
        headers: {
          Authorization: 'bearer ' + userToken,
        },
      }
      await axios(config).then((res) => {
        if (res.status === 200) setShow(true)
      })
    } catch (error) {
      console.error('Failed to update personal info:', error)
      // Handle error appropriately
    }
  }

  useEffect(() => {
    setFocus('firstName')
  }, [setFocus])

  const handleBackToSettingsClick = () => {
    navigate('/settings')
  }

  const handleGoToMainPageClick = () => {
    navigate('/')
  }

  return (
    <div className='max-w-lg mt-5 mx-auto flex flex-col h-auto border py-8 px-4 rounded-md' style={{ backgroundColor: 'var(--card-bg)', color: 'var(--text-primary)', borderColor: 'var(--border-color)' }}>
      <Helmet>
        <title className='text-xl font-semibold font-semibold'>
          ویرایش اطلاعات شخصی
        </title>
        <meta
          name='description'
          content='داستان کتاب - داستان ها همیشه در دل و ذهن می مانند'
        />
      </Helmet>
      <div className={show ? 'block' : 'hidden'}>
        <h2 className='text-lg text-start font-medium '>
          اطلاعات شخصی شما با موفقیت تغییر کرد.
        </h2>
        <div className='flex items-center justify-between w-full gap-4 my-4'>
          <button
            onClick={handleBackToSettingsClick}
            className='w-full rounded text-white uppercase border-none mt-10 p-5 text-xl font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
            style={{ backgroundColor: 'var(--accent-primary)' }}
          >
            رفتن به تنظمیات
          </button>
          <button
            onClick={handleGoToMainPageClick}
            className='w-full rounded text-white uppercase border-none mt-10 p-5 text-xl font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
            style={{ backgroundColor: 'var(--accent-primary)' }}
          >
            رفتن به صفحه اصلی
          </button>
        </div>
      </div>
      <div className={!show ? 'block' : 'hidden'}>
        <button
          onClick={handleBackToSettingsClick}
          className='rounded border-none w-full mb-4 p-4 text-white text-base cursor-pointer'
          style={{ backgroundColor: 'var(--accent-primary)' }}
        >
          بازگشت به تنظمیات
        </button>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h1 className='text-lg text-start font-medium mt-4 mb-2'>
            لطفا نام خود را وارد کنید:
          </h1>
          <input
            autoFocus
            className='input-theme block outline-none w-full rounded border p-4 mb-2.5 text-base'
            type='text'
            {...register('firstName', {
              required: 'first name is required',
            })}
          />
          {errors.firstName && (
            <p className='text-red-600 before:inline before:content-["⚠"]'>
              {' '}
              {errors.firstName.message}
            </p>
          )}

          <h1 className='text-lg text-start font-medium mt-4 mb-2'>
            لطفا نام خانوادگی خود را وارد کنید:
          </h1>

          <input
            className='input-theme block outline-none w-full rounded border p-4 mb-2.5 text-base'
            type='text'
            {...register('lastName', {
              required: 'last name is required',
            })}
          />
          {errors.lastName && (
            <p className='text-red-600 before:inline before:content-["⚠"]'>
              {' '}
              {errors.lastName.message}
            </p>
          )}
          <h1 className='text-lg text-start font-medium mt-4 mb-2'>
            لطفا ایمیل خود را وارد کنید:
          </h1>

          <input
            className='input-theme block outline-none w-full rounded border p-4 mb-2.5 text-base'
            type='email'
            {...register('email')}
            dir='ltr'
          />
          {errors.email && (
            <p className='text-[#bf1650] before:inline before:content-["⚠"]'>
              {' '}
              Email is not correct email format
            </p>
          )}

          <input
            className='w-full rounded text-white uppercase border-none mt-10 p-5 text-xl font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
            style={{ backgroundColor: 'var(--accent-primary)' }}
            type='submit'
            value='تایید'
          />
        </form>
      </div>
    </div>
  )
}
